module.exports = __webpack_public_path__ + "img/user.2566365a.svg";